import { useCustomToast } from '@elkaso-app/web-design';
import http from 'apis/config/http-service';
import { useMutationWrapper } from 'apis/config/use-api-wrapper';
import { useGetUsersApi } from 'apis/users/use-get-users-api';
import type { AxiosError } from 'axios';
import type { UseMutationOptions, UseMutationResult } from 'react-query';

const endpoint = 'ums/v1/users';
export const updateUsersEndpointIdentifier = endpoint;

interface BodyType {
  name?: string;
  email?: string;
  phoneNumber?: string;
  permittedCountries?: number[];
  roles?: number[];
  isActive?: boolean;
}

type TData = Record<string, any>;
type TError = AxiosError;

type TVariables = {
  userId: number;
  body: BodyType;
};

type Options = Omit<UseMutationOptions<TData, TError, TVariables, unknown>, 'mutationFn'>;
type ReturnType = UseMutationResult<TData, TError, TVariables>;

export function useUpdateUserApi(options?: Options): ReturnType {
  const { refetch: refetchUsers } = useGetUsersApi({ enabled: false });
  const toast = useCustomToast();

  const mutationFn = async ({ userId, body }: TVariables) => {
    try {
      const { data } = await http.patch(endpoint + `/${userId}`, body);

      // Refetch users list
      refetchUsers();

      toast({
        description: 'User have been updated successfully',
        status: 'success',
      });

      return data;
    } catch (error: any) {
      if (!error.response.status || !error.response.data.message) throw error;

      toast({
        description: error.response.data.message,
        status: 'error',
      });

      throw error;
    }
  };

  return useMutationWrapper(mutationFn, { mutationKey: endpoint, ...options });
}
